import { useTranslation } from "react-i18next";
import { ShareButton } from "@/components/ShareButton";
import { useWeekRecap } from "@/hooks/useEngagement";
import { weekCard } from "@/lib/engagement.core";
import { fmtUsd } from "@/lib/format";
import { useAssetName } from '@/lib/instruments';

/****************
 * MY WEEK, AS A CARD TO SHARE. 2026-10-21, engagement second pass.
 * The plan's weekly result card, built on the share card the app already has
 * (lib/shareCard.ts): win rate as the headline, the week's result, trades
 * closed, wins and losses, the best trade, and which money it was. Shown only
 * once something closed this week. Phone twin: components/engagement/WeekShare.
 ****************/
export function WeekShare() {
  const { t } = useTranslation("dashboard");
  const an = useAssetName();
  const { data } = useWeekRecap();
  const card = weekCard(data);
  if (!card) return null;
  const { side, paper, winRate } = card;
  return (
    <ShareButton
      label={t("week.share")}
      fileName={`copyfi-my-week`}
      data={{
        title: t("week.title"),
        subtitle: paper ? t("week.paper") : t("week.live"),
        headline: Math.round(winRate),
        headlineLabel: t("week.winRate"),
        headlinePlain: true,
        pnlUsd: side.net_pnl,
        stats: [
          { label: t("week.closed"), value: String(side.closed) },
          { label: t("week.wonLost"), value: `${side.wins} / ${side.losses}` },
          ...(side.best ? [{ label: t("week.best"), value: `${an(side.best.symbol)} ${fmtUsd(side.best.realized_pnl, 2, { sign: true })}` }] : []),
        ],
      }}
    />
  );
}
